import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { VehicleExpense, RecordExpenseRequest } from '../types';

export const vehicleExpenseService = {
  recordExpense: async (data: RecordExpenseRequest): Promise<VehicleExpense> => {
    const response = await apiClient.post<VehicleExpense>(API_ENDPOINTS.VEHICLE_EXPENSES.BASE, data);
    return response.data;
  },

  uploadAttachment: async (expenseId: number, file: File): Promise<VehicleExpense> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<VehicleExpense>(
      `${API_ENDPOINTS.VEHICLE_EXPENSES.BY_ID(expenseId)}/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  downloadAttachment: async (expenseId: number): Promise<Blob> => {
    const response = await apiClient.get<Blob>(
      `${API_ENDPOINTS.VEHICLE_EXPENSES.BY_ID(expenseId)}/attachment`,
      {
        responseType: 'blob',
      }
    );
    return response.data;
  },

  getAttachmentViewUrl: (expenseId: number): string => {
    // Return the URL for viewing attachment inline
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    return `${baseUrl}/api/vehicles/expenses/${expenseId}/attachment/view`;
  },

  getAll: async (): Promise<VehicleExpense[]> => {
    const response = await apiClient.get<VehicleExpense[]>(API_ENDPOINTS.VEHICLE_EXPENSES.BASE);
    return response.data;
  },

  getById: async (id: number): Promise<VehicleExpense> => {
    const response = await apiClient.get<VehicleExpense>(API_ENDPOINTS.VEHICLE_EXPENSES.BY_ID(id));
    return response.data;
  },

  getByVehicle: async (vehicleId: number): Promise<VehicleExpense[]> => {
    const response = await apiClient.get<VehicleExpense[]>(API_ENDPOINTS.VEHICLE_EXPENSES.BY_VEHICLE(vehicleId));
    return response.data;
  },

  getByTrip: async (tripId: number): Promise<VehicleExpense[]> => {
    const response = await apiClient.get<VehicleExpense[]>(API_ENDPOINTS.VEHICLE_EXPENSES.BY_TRIP(tripId));
    return response.data;
  },

  getPending: async (): Promise<VehicleExpense[]> => {
    const response = await apiClient.get<VehicleExpense[]>(API_ENDPOINTS.VEHICLE_EXPENSES.PENDING);
    return response.data;
  },

  approve: async (id: number): Promise<VehicleExpense> => {
    const response = await apiClient.post<VehicleExpense>(API_ENDPOINTS.VEHICLE_EXPENSES.APPROVE(id));
    return response.data;
  },

  reject: async (id: number): Promise<VehicleExpense> => {
    const response = await apiClient.post<VehicleExpense>(API_ENDPOINTS.VEHICLE_EXPENSES.REJECT(id));
    return response.data;
  },

  update: async (id: number, data: RecordExpenseRequest): Promise<VehicleExpense> => {
    const response = await apiClient.put<VehicleExpense>(API_ENDPOINTS.VEHICLE_EXPENSES.BY_ID(id), data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.VEHICLE_EXPENSES.BY_ID(id));
  },
};
